import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { Splash } from '@/components/ui/Splash';
import {
  FEATURES,
  featureFlagsReady,
  hasFeature,
} from '@/features/feature-flags';
import { PersonPage } from '@/features/people-wiki';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/people-wiki/$personId')({
  // A page that was just created opens with its name ready to be typed over
  validateSearch: z.object({ rename: z.boolean().optional() }),
  async beforeLoad() {
    await featureFlagsReady();

    if (hasFeature(FEATURES.PEOPLE_WIKI)) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  pendingComponent: () => <Splash reason="route-pending-flags-ready" />,
  component: PersonPageRoute,
});

function PersonPageRoute() {
  const { personId } = Route.useParams();
  const { rename } = Route.useSearch();
  const navigate = Route.useNavigate();
  // The page has read `rename`, and going Back or reloading must not open the name editor again
  useEffect(() => {
    if (rename) void navigate({ search: {}, replace: true });
  }, [rename, navigate]);
  return (
    <PersonPage key={personId} personId={personId} startRenaming={rename} />
  );
}
